function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/web.dom.iterable.js";
/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
const isServer = typeof window === 'undefined';
export const withDynamicImport = _ref => {
  let {
    server,
    client,
    name,
    placeholder,
    inherit
  } = _ref;
  if (isServer) return server();
  const Component = props => {
    var _props$qctx, _props$qctx$defaultVa;
    const moduleRef = useRef(null);
    const [_, forceRender] = useState();
    // declareContexts([QueryContext, ExperienceContext]);

    useEffect(() => {
      client().then(module => {
        var _moduleRef$current;
        moduleRef.current = module[name];
        if (!moduleRef.current) {
          // eslint-disable-next-line max-len
          throw new Error(`Error importing ${name} in withDynamicImport. Make sure module name matches component export name.`);
        }
        Component.dataModel = ((_moduleRef$current = moduleRef.current) === null || _moduleRef$current === void 0 ? void 0 : _moduleRef$current.dataModel) || {};
        forceRender(new Date().getTime());
      });
    }, []);
    if (!moduleRef.current) return placeholder || null;
    const queryProviderProps = props.queryProvider || {};
    // allow the component to override the QueryProvider values
    // because cacheKey may be different across sibling components
    // you want it to be the same so that there is no race condition.
    // for example, for all accordions must be the same
    // otherwise a race condition will occur generating duplicate requests
    return /*#__PURE__*/React.createElement(QueryProvider, _extends({
      defaultVariables: props === null || props === void 0 ? void 0 : (_props$qctx = props.qctx) === null || _props$qctx === void 0 ? void 0 : (_props$qctx$defaultVa = _props$qctx.defaultVariables) === null || _props$qctx$defaultVa === void 0 ? void 0 : _props$qctx$defaultVa.current,
      inherit: inherit,
      cacheKey: `dynamic-import-${name}`
    }, queryProviderProps), /*#__PURE__*/React.createElement(moduleRef.current, props));
  };
  Component.displayName = name;
  return Component;
};
//# sourceMappingURL=withDynamicImport.js.map